// The add-coverage form is populated by scraping the pasted article URL, and
// outlets increasingly bot-block that scrape. Both transitions live here so a
// failed scrape can never leave the previous article's publisher, headline and
// description sitting in the form to be saved against the new URL. The pasted
// URL is the one value we always have, so it is the fallback.
export const coverageFormDetails = (prev, pastedUrl, coverage) => ({
    ...prev,
    details: {
        title: coverage?.title || '',
        source: coverage?.publisher || '',
        url: coverage?.url || pastedUrl || '',
    },
    description: coverage?.description || '',
});
